/**
 *
 * @format
 */

/** @format */
import React from 'react';
import { Accordion } from 'react-bootstrap';
import PageLayout from 'components/Layout/Page';
import ModalWrapper from 'components/Modals';
import { LeadsSectionBody as LeadsFormLong } from './LeadsFormLong';
import { LeadsSectionBody as LeadsFormMin } from './LeadsFormMin';
import { LeadsSectionMultiStageBody } from './LeadsFormMultiStage';
export * from './constants';
import { LeadSources } from './constants';

export const LeadsSectionBody = (props) => {
  const text = props.t('lang_common:leads_generator');

  const { isMinForm = false, isMultiStage = false } = props || {};

  if (isMultiStage) {
    return <LeadsSectionMultiStageBody text={text} {...props} />;
  } else if (isMinForm) {
    return <LeadsFormMin text={text} {...props} />;
  } else {
    return <LeadsFormLong text={text} {...props} />;
  }
};

export function LeadsGeneratorAccordion(props) {
  const text = props.t('lang_common:leads_generator');

  return (
    <div className='leads-generator-accordion-wrapper'>
      <Accordion className='leads-generator-accordion' alwaysOpen={false}>
        <Accordion.Item eventKey={0} key={0}>
          <Accordion.Header className='leads-generator-accordion-header'>
            <span className='leads-generator-accordion-header-title d-flex justify-content-center w-100'>
              {text.accordion.header.label}
            </span>
          </Accordion.Header>
          <Accordion.Body>
            <LeadsSectionBody {...props} />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

export function LeadsGeneratorPage(props) {
  return (
    <PageLayout {...props}>
      <div className='leads-generator-page-wrapper'>
        <LeadsSectionBody
          metadata={{
            source: LeadSources.FM_SELL_AND_BUY
          }}
          {...props}
        />
      </div>
    </PageLayout>
  );
}

export function LeadsGeneratorModal(props) {
  const { open, handler } = props;
  return (
    <ModalWrapper
      className='leads-generator-modal'
      openModal={handler}
      open={open}>
      <LeadsSectionBody {...props} />
    </ModalWrapper>
  );
}
